import { DeviceSerialNumberParamSchema, EfemAdapterAssignmentResponseSchema, EfemAdapterRegistryListResponseSchema, LocationAdapterAssignmentResponseSchema, LocationAdapterRegistryListResponseSchema, PutEfemAdapterAssignmentBodySchema, PutLocationAdapterAssignmentBodySchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/provider/gateway-adapter-assignment.routes.ts`. */
export const providerGatewayAdaptersContract = {
    listEfemRegistry: {
        method: 'GET',
        path: '/provider/gateway-adapters/efem/registry',
        response: EfemAdapterRegistryListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list EFEM adapter registry',
    },
    listLocationRegistry: {
        method: 'GET',
        path: '/provider/gateway-adapters/location/registry',
        response: LocationAdapterRegistryListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list location adapter registry',
    },
    getEfemAssignment: {
        method: 'GET',
        path: '/provider/gateway-adapters/efem/gateways/:serialNumber/assignment',
        pathParams: DeviceSerialNumberParamSchema,
        response: EfemAdapterAssignmentResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get EFEM adapter assignment',
    },
    getLocationAssignment: {
        method: 'GET',
        path: '/provider/gateway-adapters/location/gateways/:serialNumber/assignment',
        pathParams: DeviceSerialNumberParamSchema,
        response: LocationAdapterAssignmentResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get location adapter assignment',
    },
    putEfemAssignment: {
        method: 'PUT',
        path: '/provider/gateway-adapters/efem/gateways/:serialNumber/assignment',
        pathParams: DeviceSerialNumberParamSchema,
        body: PutEfemAdapterAssignmentBodySchema,
        response: EfemAdapterAssignmentResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to save EFEM adapter assignment',
    },
    putLocationAssignment: {
        method: 'PUT',
        path: '/provider/gateway-adapters/location/gateways/:serialNumber/assignment',
        pathParams: DeviceSerialNumberParamSchema,
        body: PutLocationAdapterAssignmentBodySchema,
        response: LocationAdapterAssignmentResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to save location adapter assignment',
    },
};
//# sourceMappingURL=provider-gateway-adapters.contract.js.map